import client from 'services/networking/client';
import type { Customer } from 'shared-types/customer';
import type { OffersMessageAndModalResponse, UserPlan } from 'shared-types/user';

export const getCurrentUserPlan = async (): Promise<UserPlan> => {
  return client.get('/user/plan');
};

export const cancelSubscription = async (): Promise<void> => {
  return client.post('/user/cancel-subscription', {});
};

export const updateUserEmail = async (newEmail: string): Promise<void> => {
  return client.patch('/user/update-email', { email: newEmail });
};

export const startFreeTrial = async (): Promise<void> => {
  return client.post('/user/start-free-trial', {});
};

export const getOffersMessageAndModal = async (): Promise<OffersMessageAndModalResponse> => {
  return client.get('/user/offers-message-and-modal');
};

export const getCustomer = async (customerId: number): Promise<Customer> => {
  return client.get(`/customer/external/${customerId}`);
};
